<template>
  <div class="overflow-hidden rounded-[4px] border border-[#E3E5EB]">
    <table class="border-collapse table-auto min-w-full text-[16px] line-height-[24px] font-[400] color-[#000000]">
      <tbody class="bg-transparent">
        <tr
          v-for="(item, index) in data"
          :key="index"
          class="border-b border-[#E3E5EB] last:border-b-0"
        >
          <td class="w-[160px] pl-[32px] pr-[16px] py-[16px]">
            {{ moment.unix(item.created).format('MMM DD, YYYY') }}
          </td>
          <td class="p-[16px] font-[500]">
            {{ item.price }}
          </td>
          <td>
            <span
              v-if="item.status === 'paid'"
              class="rounded h-5 capitalize text-xs bg-[#5DC24D] text-white font-medium inline-flex px-2.5 items-center justify-center"
            >
              {{ item.status }}
            </span>
            <span
              v-else
              class="rounded h-5 capitalize text-xs bg-[#D5D5D5] text-[#9A9A9A] font-medium inline-flex px-2.5 items-center justify-center"
            >
              {{ item.status }}
            </span>
          </td>
          <td class="w-[200px] text-right pl-[16px] pr-[32px] py-[16px]">
            ${{ item.total / 100 }} USD
          </td>
          <td class="w-[160px] text-right pl-[16px] pr-[32px] py-[16px]">
            <a
              class="color-[#4F83E3] hover:underline"
              :href="item.hosted_invoice_url"
              target="_blank"
            >
              Download
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BillingHistoryTable',
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>